export const DOCUMENT_PATHS = {
  politicaDePrivacidade: '/docs/politica-de-privacidade.pdf',
  relatorioIgualdadeSalarial: '/docs/relatorio-igualdade-salarial-2026.pdf',
  relatorioSustentabilidade: '/docs/relatorio-sustentabilidade-2025.pdf',
} as const;

export const openDocument = (path: string) => {
  window.open(path, '_blank');
};
